import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "@mdlegion/shared/components/App";
import { PublicConfigProvider } from "@mdlegion/shared/components/PublicConfigProvider";
import "./index.css";

declare global {
  interface Window {
    __PUBLIC_CONFIG__?: import("@mdlegion/shared").PublicConfig;
  }
}

const cfg = window.__PUBLIC_CONFIG__;
if (!cfg) {
  throw new Error(
    "Public config missing — server must inject /config.js before the app bundle."
  );
}

// Only override the stylesheet default with a value that is actually a valid
// hex color — a mangled config value (e.g. wrapped in literal quotes) would
// otherwise make bg-program compute to invalid and blank the header.
if (/^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(cfg.primaryColor ?? "")) {
  document.documentElement.style.setProperty("--program-primary", cfg.primaryColor);
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <PublicConfigProvider value={cfg}>
      <App />
    </PublicConfigProvider>
  </React.StrictMode>
);
